import { TicketAttachmentDocumentType } from '../tickets/ticket-attachment-document-type.enum';

export interface ICustomerAppPermissions {
  permissions: IPermissions;
  residentAppSettings: IResidentAppSettings;
  ticketSettings: ITicketSettings;
}

export interface ICustomerAppPermissionsResponse {
  bookedModulesResponseBean: IBookedModulesPermissions;
  residentAppSettings: IResidentAppSettings;
  ticketSettings: ITicketSettings;
}

export interface IBookedModulesPermissions {
  whitelabelCustomerPortal: boolean;
  consumptionDataVisualization: boolean;
  internalTicketing: boolean;
  payment: boolean;
  chatbot: boolean;
}

export interface IResidentAppSettings {
  ticketingVersion: TicketingVersion;
  consumptionDataVersion?: ConsumptionDataVersion;
  documentSortingSupported: boolean;
  showStartPageBanner: boolean;
  startPageBannerHeadline: string;
  startPageBannerText: string;
  showFaqCard: boolean;
  faqCardHeadline: string;
  faqCardText: string;
}

export interface ITicketSettings {
  damageTicketingType: TicketingType;
  concernTicketingType: TicketingType;
  allowContractlessTicketCreationForDamages: boolean;
  allowContractlessTicketCreationForOtherConcerns: boolean;
  allowedDamageTicketAttachmentFileTypes: TicketAttachmentDocumentType[];
  allowedConcernTicketAttachmentFileTypes: TicketAttachmentDocumentType[];
  enableTicketMessengerForDamages: boolean;
  enableTicketMessengerForConcerns: boolean;
  damageMessagesReadOnly: boolean;
  concernMessagesReadOnly: boolean;
}

export type IPermissions = IBookedModulesPermissions;

export enum TicketingVersion {
  HIERARCHICAL = 'HIERARCHICAL', // old ticketing
  METADATA = 'METADATA', // metadata ticketing
}

export enum TicketingType {
  INTERNAL = 'INTERNAL',
  FULL_SYNC = 'FULL_SYNC',
  EXTERNAL = 'EXTERNAL',
}

export enum ConsumptionDataVersion {
  INTERNAL = 'INTERNAL', // new internal uVI API
  EXTERNAL = 'EXTERNAL', // old standard for Gebausie/BGM/WGH etc
}
